import React from 'react';
import Result from "../../components/PowerBiModule/Result";
import { GmsContextProvider } from '../../context/gmsContext';
import { PowerBiContextProvider } from '../../context/PowerBiContext';

const PowerBiModule = () => {
    return (
        <PowerBiContextProvider>
            <Result/>
        </PowerBiContextProvider>
    );
};

export default PowerBiModule;
